import { render, staticRenderFns } from "./DeniedCard.vue?vue&type=template&id=be991cca"
import script from "./DeniedCard.vue?vue&type=script&lang=js"
export * from "./DeniedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports